// Colors (RGB values)
export const COLORS = {
  text: { r: 31, g: 35, b: 40 },        // #1f2328
  gray: { r: 89, g: 99, b: 110 },       // #59636e
  lightGray: { r: 129, g: 139, b: 152 }, // #818b98
  border: { r: 209, g: 217, b: 224 },   // #d1d9e0
  background: { r: 246, g: 248, b: 250 }, // #f6f8fa
  tableHeaderBackground: { r: 230, g: 235, b: 240 }, // #e6ebf0
  // Rating colors matching SingleRating.vue component
  ratingA: { r: 46, g: 125, b: 50 },    // #2e7d32
  ratingB: { r: 76, g: 175, b: 80 },    // #4caf50
  ratingC: { r: 251, g: 140, b: 0 },   // #fb8c00
  ratingD: { r: 231, g: 81, b: 34 },    // #e75122
  ratingF: { r: 200, g: 48, b: 48 },    // #c83030
  // Finding type colors matching PrimeVue severities
  findingGoodPoint: { r: 46, g: 125, b: 50 },    // #2e7d32 (success - green)
  findingObservation: { r: 33, g: 150, b: 243 }, // #2196f3 (info - blue)
  findingMinorNc: { r: 251, g: 140, b: 0 },      // #fb8c00 (warn - orange)
  findingMajorNc: { r: 200, g: 48, b: 48 },      // #c83030 (danger - red)
  findingNoFinding: { r: 89, g: 99, b: 110 },    // #59636e (secondary - gray)
}

// Rating letter to color map (for use in rating badges)
export const RATING_COLORS: Record<string, RgbColor> = {
  A: COLORS.ratingA,
  B: COLORS.ratingB,
  C: COLORS.ratingC,
  D: COLORS.ratingD,
  F: COLORS.ratingF,
}

// Page dimensions (A4 in mm)
export const PAGE = {
  width: 210,
  height: 297,
  marginLeft: 15,
  marginRight: 15,
  marginTop: 20,
  marginBottom: 20,
  headerHeight: 12,
  footerHeight: 12,
}

export const CONTENT_WIDTH = PAGE.width - PAGE.marginLeft - PAGE.marginRight

// RGB color type
export interface RgbColor {
  r: number
  g: number
  b: number
}
